import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-range-date-input',
  templateUrl: './range-date-input.component.html',
  styleUrls: ['./range-date-input.component.scss'],
})
export class RangeDateInputComponent {}
